<script>
	import '../app.css';
	import '$lib/api/axios-config';
	import ConfirmDialog from '$lib/components/ConfirmDialog.svelte';

	// Use $props to access children (the default slot)
	const { children } = $props();
</script>

{@render children()}

<!-- Shared by every route, so confirmAction() works wherever it is called. -->
<ConfirmDialog />
